import axios from "axios"
import { putRes } from "./reservationsSlice"


export function reservationsPutAxios(resData) {
        return async function reservationsThunk(dispatch, getState) {
            const response = await axios.put(`/api/reservations`, resData)
            dispatch(putRes(response.data))
        };
    }